/**
 * Firebase Analytics wrapper
 * GDPR compliant: No PII collected, anonymous event tracking only
 */

import { getAnalytics, logEvent, setAnalyticsCollectionEnabled } from "firebase/analytics";
import app from "../firebase/config";

// Initialize Firebase Analytics
let analytics = null;

const isBrowser = typeof window !== "undefined";

if (isBrowser) {
  try {
    analytics = getAnalytics(app);
    // Analytics collection is enabled by default
    // Users can opt-out via browser settings or cookie consent
  } catch (error) {
    console.warn("Firebase Analytics initialization failed:", error);
  }
}

/**
 * Track a custom event
 * @param {string} eventName - Event name (snake_case recommended)
 * @param {object} params - Event parameters (no PII)
 */
export function trackEvent(eventName, params = {}) {
  if (!analytics) return;

  try {
    logEvent(analytics, eventName, params);
  } catch (error) {
    console.warn("Failed to track event:", error);
  }
}

/**
 * Track successful analysis completion
 */
export function trackAnalysisResult(authStatus, metadata = {}) {
  trackEvent("analysis_complete", {
    auth_status: authStatus,
    cache_status: metadata.cache_status || "unknown",
    model_version: metadata.model_version || "unknown",
  });
}

/**
 * Track analysis error
 */
export function trackAnalysisError(authStatus, category = "other") {
  trackEvent("analysis_failed", {
    auth_status: authStatus,
    category,
  });
}

/**
 * Enable or disable analytics collection (for GDPR consent)
 */
export function setAnalyticsEnabled(enabled) {
  if (analytics) {
    setAnalyticsCollectionEnabled(analytics, enabled);
  }
}
